import MassFreezeDialog from "./MassFreezeDialog";

export default MassFreezeDialog;
